import Link from 'next/link'

const DnevnePlus = () => {
  return (
    <div className="w-full h-full absolute top-0 left-0 bg-white pt-48">
      <div className="flex items-start justify-center flex flex-col">
        <div className="w-full">
          <p
            style={{ fontFamily: 'lato-bold', color: 'gray' }}
            className="font-black lg:text-5xl mb-2 text-center"
          >
            Stranica je u izradi
          </p>
          <p
            style={{ fontFamily: 'lato-bold', color: 'gray' }}
            className="font-black text-5xl text-center"
          >
            Posetite nas kasnije.
          </p>
        </div>
        <div className="flex justify-center w-full">
          <img className="h-60" src="/worker.jpeg" />
        </div>
      </div>
      <div className="flex justify-center underline mt-16">
        <Link href="/">Nazad na naslovnu</Link>
      </div>
    </div>
  )
}

export default DnevnePlus
